
import HTTP from '@/utils/explorerHttp'
export default {
  namespaced: true,

  actions: {
    getExplorerLastInfo() {
      return HTTP({ method: "get", url: "explorer/information/best/" });
    },
  }
};
